// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
    // init ALL Swipers on the page (one per property card):
    document.querySelectorAll('.swiper').forEach((swiperElement, index) => {
        const slideCount = swiperElement.querySelectorAll('.swiper-slide').length;

        console.log(`Swiper ${index}: found ${slideCount} slides`);

        new Swiper(swiperElement, {
            // Optional parameters
            direction: 'horizontal',
            loop: false,

            // Enable slide change
            slidesPerView: 1,
            spaceBetween: 0,

            // Explicitly set observer to update on changes
            observer: true,
            observeParents: true,

            // If we need pagination
            pagination: {
                el: swiperElement.querySelector('.swiper-pagination'),
                clickable: true,
                dynamicBullets: true,
            },

            // Navigation arrows
            navigation: {
                nextEl: swiperElement.querySelector('.swiper-button-next'),
                prevEl: swiperElement.querySelector('.swiper-button-prev'),
            },

            // And if we need scrollbar
            scrollbar: {
                el: swiperElement.querySelector('.swiper-scrollbar'),
            },

            // Debug callback
            on: {
                init: function() {
                    console.log(`Swiper ${index} initialized with ${this.slides.length} slides`);
                },
                slideChange: function() {
                    console.log(`Swiper ${index} changed to slide ${this.activeIndex}`);
                },
            },
        });
    });
});
